<script>
import OrderSessionsList from '@components/List/OrderSessionsList'
import OrderInfo from './OrderInfo'
import formatDate from '@utils/format-date'
import { orderRegStatusItem, orderShowQrcode } from '@utils/zerone-order'

export default {
  components: {
    OrderSessionsList,
    OrderInfo,
  },
  props: {
    orderItem: {
      type: Object,
      default: () => {
        return {
          title: 'Modernweb 2021(單天實體統一報名)',
          alias: 'modernweb2021',
          dateType: 'single',
          type: 'physical', // 實體
          registrationType: 'impartial', // 統一
          seriesNum: 'IU767',
          regStatus: 'CONFIRMED',
          dateTimeRange: '2021/11/01(ㄧ) (10:00-14:40)',
          locationName: '張榮發國際會議中心',
          fullAddress: '臺北市中正區中山南路11號11樓',
          lat: 25.1234567,
          lng: 121.02564,
          qrcode: '5JIEkZF6sMSjftqbQbdqpODdSqONfIU9iEh6FvUx7T9WooCVUwnrK4cxYM9jz7MUywV2ehYDVHQCr1GrRsxbNMnFRDEcjzcueSVU6OzMZe74JL3lfMiRZTivP5q2d8pw',
          orders: [
            // {
            //     "orderNum": "ZERONE2110250007",
            //     "fullName": "傅惠貞",
            //     "gender": "male",
            //     "email": "turbo@hotmail.com.tw",
            //     "phoneCode": "+886",
            //     "phoneNumber": "0953053253",
            //     "note": null
            // },
            {
              orderNum: 'ZERONE21123457820',
              fullName: '傅惠貞',
              gender: 'male',
              email: 'turbo@hotmail.com.tw',
              phoneCode: '+886',
              phoneNumber: '0953053253',
              note: null,
            },
          ],
          sessions: [
            {
              date: '2021-11-01',
              sessions: [
                {
                  title: 'Digital and Application Innovation2',
                  startTime: '09:00',
                  endTime: '10:40',
                  checkinStatus: 'NOSHOW',
                  info: {
                    introtext: 'test',
                    personnels: [
                      {
                        name: 'Jordan',
                        categoryTitle: '工程師',
                        companyName: '詠大心創意國際',
                        title: '後端工程師',
                        avatar: 'avatar.jpg',
                        description: null,
                      },
                      {
                        name: 'Jerry',
                        categoryTitle: '工程師',
                        companyName: '詠大心創意國際',
                        title: '後端工程師',
                        avatar: 'avatar.jpg',
                        description: null,
                      },
                    ],
                    files: [],
                  },
                },
                {
                  title: 'Digital and Application Innovation',
                  startTime: '10:00',
                  endTime: '12:40',
                  checkinStatus: 'COMPLETED',
                  info: {
                    introtext: 'test',
                    personnels: [
                      {
                        name: 'Jordan',
                        categoryTitle: '工程師',
                        companyName: '詠大心創意國際',
                        title: '後端工程師',
                        avatar: 'avatar.jpg',
                        description: null,
                      },
                      {
                        name: 'Jerry',
                        categoryTitle: '工程師',
                        companyName: '詠大心創意國際',
                        title: '後端工程師',
                        avatar: 'avatar.jpg',
                        description: null,
                      },
                    ],
                    files: [],
                  },
                },
                {
                  title: '從 React 到 React Native 到 React Native Web 開發與設計須知',
                  startTime: '12:45',
                  endTime: '13:05',
                  checkinStatus: 'FORBIDDEN',
                  info: null,
                },
                {
                  title: '善用UX來提升UU：打造滿足新手和專家的UI',
                  startTime: '13:50',
                  endTime: '16:30',
                  checkinStatus: 'CHECKIN',
                  info: {
                    introtext: 'test',
                    personnels: [
                      {
                        name: 'Jordan',
                        categoryTitle: '工程師',
                        companyName: '詠大心創意國際',
                        title: '後端工程師',
                        avatar: 'avatar.jpg',
                        description: null,
                      },
                      {
                        name: 'Jerry',
                        categoryTitle: '工程師',
                        companyName: '詠大心創意國際',
                        title: '後端工程師',
                        avatar: 'avatar.jpg',
                        description: null,
                      },
                    ],
                    files: [],
                  },
                },
              ],
            },
          ],
          meal: [
            {
              date: '2021-11-01',
              value: '葷食餐點',
            },
          ],
          brands: [
            {
              alias: 'aimetis',
              logo: null,
            },
            {
              alias: 'f5',
              logo: null,
            },
          ],
        }
      },
    },
  },
  data() {
    return {
      activeTab: '報名詳情',
      detail: 'detail',
      live: 'live',
      activeNames: [0],
    }
  },
  computed: {
    infoList() {
      const list = () => {
        return this.orderItem.orders.map((item) => {
          return {
            alias: item.orderNum,
            info: [
              {
                title: '詳細資訊',
                textList: [
                  {
                    title: '成立時間',
                    text: formatDate(item.createdAt, 'yyyy/MM/dd HH:mm'),
                    class: 'mb-2',
                  },
                  {
                    title: '報名方式',
                    text: item.coupon ? `指定上課卷 (${item.coupon.title} : ${item.coupon.code})` : '無指定上課卷',
                    class: '',
                  },
                ],
              },
              {
                title: '報名資訊',
                textList: [
                  {
                    title: '參與人姓名',
                    class: 'mb-2',
                    text: `${item.fullName}`,
                  },
                  {
                    title: '參與人手機',
                    class: 'mb-2',
                    text: `${item.phoneCode} ${item.phoneNumber}`,
                  },
                  {
                    title: '參與人電子郵件',
                    class: 'mb-2',
                    text: `${item.email}`,
                  },
                  {
                    title: '備註',
                    class: '',
                    text: `${item.note ? item.note : '無'}`,
                  },
                ],
              },
            ],
          }
        })
      }
      return list()
    },
    regStatusItem() {
      return orderRegStatusItem(this.orderItem.regStatus)
    },
    showQrcode() {
      return orderShowQrcode(this.orderItem.showQrcode, this.orderItem.regStatus)
    },
  },
  methods: {
    goTo(item) {
      this.activeTab = item
      this.scrollTo()
    },
    scrollTo() {
      const top = this.$refs['tabPane'].$el.offsetTop - 150

      window.scrollTo({ top, behavior: 'smooth' })
    },
    takeLast(text, num = 5) {
      return text.substring(text.length - num, text.length)
    },
  },
}
</script>

<template>
  <div :class="$style.memberTabList" class="sectionMemberCourseList__bottomBox mt-5">
    <el-tabs ref="tabPane" v-model="activeTab" stretch class="isStyleBase">
      <el-tab-pane label="報名詳情" name="報名詳情" class="director">
        <OrderSessionsList :order-item="orderItem" :detail="detail" class="sectionMemberCourseList__OrderSessionsList" />
        <el-collapse v-if="infoList.length > 1" v-model="activeNames" class="isStyleOrder isStylePrimaryLight">
          <el-collapse-item
            v-for="(infoItem, $index) in infoList"
            :key="$index"
            :title="`${orderItem.categoryTitle}編號：${infoItem.alias}`"
            class="sectionMemberCourseList__bottomBox__list"
            :name="$index"
          >
            <OrderInfo :order-item="infoItem.info" />
          </el-collapse-item>
        </el-collapse>
        <template v-else>
          <div v-for="(infoItem, $index) in infoList" :key="$index" class="sectionMemberCourseList__bottomBox__list">
            <OrderInfo :order-item="infoItem.info" />
            <!-- <div class="row sectionMemberCourseList__bottomBox__list__item no-gutters">
              <div class="col-md-3 col-12 title">欄位資訊</div>
              <div class="col-md-9 col-12 content">
                <div>
                  您是否第一次參與科技研討會？<br>
                  回答：<span class="color-gray-7">是</span>
                </div>
                <el-divider></el-divider>
                <div>
                  您對於零壹科技研討會有什麼建議？<br>
                  回答：<span class="color-gray-7">回答測試文字回答測試文字回答測試文字回答測試文字回答測試文字回答測試文字回答測試文字回答測試文字回答測試文字回答測試文字回答測試文字回答測試文字</span>
                </div>
              </div>
            </div> -->
          </div>
        </template>
        <BaseButton v-if="orderItem.type === 'physical' && orderItem.regStatus !== 'CANCELED'" class="isStylePrimary isFull isRadius mt-5" :disabled="!orderItem.showQrcode" @click="goTo('電子憑證')">
          使用電子憑證
        </BaseButton>
        
        <BaseButton
          v-else-if="orderItem.type === 'online' && orderItem.regStatus !== 'CANCELED'"
          class="isStylePrimary isFull isRadius mt-5 sectionMemberCourseList__regStatusBtn"
          @click="goTo('線上直播')"
        >
          查看直播連結
        </BaseButton>
      </el-tab-pane>
      <el-tab-pane v-if="orderItem.type === 'online'" label="線上直播" name="線上直播" class="online">
        <OrderSessionsList online-type :order-item="orderItem" :live="live" class="sectionMemberCourseList__OrderSessionsList" />
      </el-tab-pane>
      <el-tab-pane v-if="orderItem.type === 'physical'" label="電子憑證" name="電子憑證" class="director">
        <div v-if="orderItem.showQrcode && orderItem.qrcode" class="row sectionMemberCourseList__bottomBox__list__item no-gutters">
          <div class="d-flex flex-column mx-auto">
            <img alt="qrcode" :src="`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${orderItem.qrcode}&chld=L|0`" class="mb-2" />
            <div class="text-sm md:text-base text-center"> 憑證編號末五碼 : {{ takeLast(orderItem.qrcode, 5) }} </div>
          </div>
        </div>
        <div class="row sectionMemberCourseList__bottomBox__list__item no-gutters">
          <div class="col-md-3 col-12 title">電子憑證</div>
          <div class="col-md-9 col-12 content">
            {{ showQrcode.qrCodeTitle }}
          </div>
        </div>
        <div class="row sectionMemberCourseList__bottomBox__list__item no-gutters">
          <div class="col-md-3 col-12 title">入場憑證使用說明</div>
          <div class="col-md-9 col-12 content">
            <div class="color-primary">如何進場？</div>
            <ol>
              <li>請於現場出示下方QR Code憑證入場，無論使用手機、平板或列印，皆可順利報到。</li>
            </ol>
            <div class="color-primary mt-md-5 mt-3">電子憑證使用須知</div>
            <ol>
              <li>以下QR Code即為您參加活動的電子票券，每張票券僅限該場活動使用，恕無法持其他任何憑證要求入場。</li>
              <li>零壹科技保留票券使用最終解釋權</li>
            </ol>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<style lang="scss" module>
.memberTabList {
  :global {
    .sectionMemberCourseList {
      &__OrderSessionsList {
        padding-bottom: 0.8rem;
        margin-bottom: 2.5rem;
        border-bottom: 1px solid #e6e6e6;
        @include max-md {
          margin-bottom: 1rem;
          padding-bottom: 1rem;
        }
      }
      &__regStatusBtn {
        @include max-md {
          padding: 1rem 0;
        }
      }
      &__bottomBox {
        &__list {
          &__title {
          }

          &__item {
            padding: 3.125rem 2.25rem;
            @include max-md {
              padding: 1.5rem 0;
            }

            &:first-child {
              // padding-top: 0;
            }

            &:not(:last-child) {
              border-bottom: 1px solid #e6e6e6;
            }

            .title {
              font-size: 20px;
              font-weight: 500;

              @include max-md {
                padding-bottom: 20px;
                font-size: 1rem;
              }
            }

            .content {
              font-size: 1.125rem;
              line-height: 1.85;
              color: $color-gray-6;
              @include max-md {
                font-size: 0.875rem;
              }
            }
          }
        }
      }

      &__Btn {
        .baseButton {
          &:not(:last-child) {
            margin-right: 1rem;
          }
        }
      }
    }
  }
}
</style>
